var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listing-item-skeleton"},[_c('v-skeleton-loader',{staticClass:"listing-item-skeleton__image",attrs:{"type":"image"}}),_c('v-skeleton-loader',{staticClass:"listing-item-skeleton__text",attrs:{"type":"text"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }